import { useMemo } from 'react';
import cloneDeep from 'clone-deep';
import { transformTheme } from '../styling/theme/transformTheme';
import { merge } from '.';
import { useTheme } from '../styling';
export var useComponentTheme = function useComponentTheme(classPrefix, defaultComponentTheme) {
  var theme = useTheme();
  useMemo(function () {
    var armor = theme.armor;

    if (!(classPrefix in armor.componentOverrides)) {
      var override = {};
      var components = armor.components;

      if (defaultComponentTheme) {
        var chunk = merge(defaultComponentTheme, components[classPrefix]);
        override = transformTheme(armor, chunk, classPrefix);
      } else {
        override = classPrefix in components ? cloneDeep(components[classPrefix]) : {};
      }

      armor.componentOverrides[classPrefix] = override;
    }

    return true;
  }, [classPrefix, theme, defaultComponentTheme]);
  return theme.armor;
};